export const INSTRUMENTS = ['Vox', 'Guitarist', 'Keys', 'Drums', 'Brass', 'Bass', 'BV'];

export const defaultPositionsForEventType = (eventType) => {
  const id = () => Math.random().toString(36).slice(2, 10);
  switch (eventType) {
    case 'Duo':
      return [
        { id: id(), role: 'primary', instrument: 'Vox', status: 'Open', applied: [], invited: false, artistId: '', artistName: '', artistEmail: '', artistNumber: '', artistImg: '', fee: 0 },
        { id: id(), role: 'member', instrument: 'Guitarist', status: 'Open', applied: [], invited: false, artistId: '', artistName: '', artistEmail: '', artistNumber: '', artistImg: '', fee: 0 },
      ];
    case 'Band':
      return [
        { id: id(), role: 'primary', instrument: 'Vox', status: 'Open', applied: [], invited: false, artistId: '', artistName: '', artistEmail: '', artistNumber: '', artistImg: '', fee: 0 },
        { id: id(), role: 'member', instrument: 'Guitarist', status: 'Open', applied: [], invited: false, artistId: '', artistName: '', artistEmail: '', artistNumber: '', artistImg: '', fee: 0 },
        { id: id(), role: 'member', instrument: 'Bass', status: 'Open', applied: [], invited: false, artistId: '', artistName: '', artistEmail: '', artistNumber: '', artistImg: '', fee: 0 },
        { id: id(), role: 'member', instrument: 'Keys', status: 'Open', applied: [], invited: false, artistId: '', artistName: '', artistEmail: '', artistNumber: '', artistImg: '', fee: 0 },
        { id: id(), role: 'member', instrument: 'Drums', status: 'Open', applied: [], invited: false, artistId: '', artistName: '', artistEmail: '', artistNumber: '', artistImg: '', fee: 0 },
      ];
    case 'DJ':
      return [
        { id: id(), role: 'primary', instrument: 'DJ', status: 'Open', applied: [], invited: false, artistId: '', artistName: '', artistEmail: '', artistNumber: '', artistImg: '', fee: 0 },
      ];
    case 'Dancer':
      return [
        { id: id(), role: 'primary', instrument: 'Dancer', status: 'Open', applied: [], invited: false, artistId: '', artistName: '', artistEmail: '', artistNumber: '', artistImg: '', fee: 0 },
      ];
    case 'Solo':
    default:
      return [
        { id: id(), role: 'primary', instrument: 'Vox', status: 'Open', applied: [], invited: false, artistId: '', artistName: '', artistEmail: '', artistNumber: '', artistImg: '', fee: 0 },
      ];
  }
};

export const rosterLabel = (positions) => {
  if (!positions?.length) return null;
  const y = positions.length;
  const x = positions.filter((p) => p.status === 'Confirmed').length;
  return `${x}/${y}`;
};

export const eventHasApplicants = (event) => {
  if ((event?.applied || []).length > 0) return true;
  return (event?.positions || []).some((p) => (p.applied || []).length > 0);
};
